<template>
  <div class="branch-editor" style="display:flex;height:100%;">
    <a-card style="width:540px;margin-right:32px;overflow:auto;height:100%;">
      <a-button type="dashed" icon="deployment-unit" @click="visualVisible = true">
        预览关系图
      </a-button>
      <a-tree v-if="treeData.length > 0" :tree-data="treeData"
        :replace-fields="{ children: 'children', title: 'title', key: 'key' }" :default-expand-all="true"
        @select="onTreeSelect" :selectedKeys="selectedNode ? [selectedNode.id] : []"
        style="max-height:550px;overflow:auto">
        <template slot="title" slot-scope="item">
          <div :class="{ 'selected-node-tree': selectedNode && selectedNode.id === item.id }"
            style="display: flex; align-items: center;">
            {{ item.nodeName || '节点 ' + item.id }}

            <a-tag v-if="item.isStart" color="green" style="margin-left: 8px; font-size: 10px;">起始</a-tag>

            <a-tag v-else-if="!item.nextNodeId && item.children && item.children.length > 0" color="blue"
              style="margin-left: 8px; font-size: 10px;">选择</a-tag>

            <a-tag v-else-if="!item.nextNodeId && item.children.length === 0" color="red"
              style="margin-left: 8px; font-size: 10px;">结束</a-tag>
          </div>
        </template>
      </a-tree>
      <!-- <div v-else-if="videoIdInput && nodes.length === 0" style="padding: 10px; color: #999;">
        未找到任何节点。
      </div> -->

      <div style="margin-top:8px;display:flex;gap:8px">
        <a-button type="primary" @click="openNewNodeModal">新建节点</a-button>
        <a-button @click="openBatchUploadModal">批量上传视频</a-button>
        <a-button @click="refresh">刷新</a-button>
      </div>
    </a-card>

    <a-card style="flex:1;overflow:auto;height:100%;">
      <div v-if="!selectedNode" style="padding:24px;color:#666">
        请选择左侧节点以查看/编辑
      </div>

      <div v-else>
        <template>
          <div>
            <h3 style="display: flex; align-items: center; margin-bottom: 16px;">

              <template v-if="isNameEditing">
                <a-input ref="nameInput" v-model="editingNodeName" style="width: 300px; margin-right: 8px;"
                  @pressEnter="submitNameEdit" />
                <a-button-group>
                  <a-button type="primary" icon="check" size="small" @click="submitNameEdit" />
                  <a-button icon="close" size="small" @click="cancelNameEdit" />
                </a-button-group>
              </template>

              <template v-else>
                节点：{{ selectedNode.nodeName }}
                <a-icon type="edit" style="cursor: pointer; margin-left: 8px; color: #1890ff;" @click="startNameEdit" />
              </template>
            </h3>

            <a-descriptions bordered :column="{ xxl: 3, xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }" size="small"
              style="margin-bottom: 16px;">
            </a-descriptions>

          </div>
          <node-visual-modal :visible.sync="visualVisible" :nodes="nodes" />
        </template>

        <a-descriptions bordered :column="{ xxl: 3, xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }" size="small"
          style="margin-bottom: 16px;">

          <a-descriptions-item label="下一节点 (线性)" :span="2">
            <div style="display: flex; align-items: center; gap: 8px;">
              <a-select style="width: 200px;" show-search option-filter-prop="children" :value="selectedNode.nextNodeId"
                allowClear placeholder="选择下一节点" @change="(value) => updateNextNodeId(value)">
                <a-select-option v-for="node in nodes" :key="node.id" :value="node.id"
                  :disabled="isNextNodeDisabledByContext(selectedNode.id, selectedNode.nextNodeId, node.id)">
                  {{ node.nodeName }}
                </a-select-option>
              </a-select>

              <template v-if="selectedNode.nextNodeId">
                <span style="color: #1890ff; margin-left: 8px;">
                  ({{ getNodeName(selectedNode.nextNodeId) }})
                </span>
              </template>
              <template v-else>
                <a-tag color="red">未设置</a-tag>
              </template>
            </div>
          </a-descriptions-item>

          <!-- <a-descriptions-item label="视频 URL (中文)">
            <div :title="selectedNode.videoUrl">{{ selectedNode.videoUrl || '-' }}</div>
          </a-descriptions-item> -->
        </a-descriptions>

        <a-divider style="margin: 8px 0;" />

        <h4>📹 多语言视频预览</h4>

        <div style="display: flex; flex-wrap: wrap; gap: 16px;">

          <div v-for="(item, fieldName) in getLangUrls" :key="fieldName"
            style="flex: 1 1 calc(33.33% - 16px); min-width: 280px; border: 1px solid #f0f0f0; padding: 10px; border-radius: 4px;">

            <div style="margin-bottom: 8px; display: flex; justify-content: space-between; align-items: center;">

              <div style="flex: 1; min-width: 0; margin-right: 8px;">
                <span style="font-weight: bold; margin-right: 4px;">{{ item.name }}:</span>
                <span :title="item.url"
                  style="font-size: 12px; color: #666; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                  <!-- {{ item.url }} -->
                </span>
              </div>

              <a-upload name="file" :showUploadList="false" :customRequest="() => { }"
                @change="(info) => handleLanguageVideoUpload(info, fieldName, item.id)">
                <a-button type="primary" size="small">
                  <a-icon type="upload" /> 重新上传
                </a-button>
              </a-upload>
            </div>

            <div style="width: 100%;">
              <video v-if="item.url" controls width="100%" height="auto" :src="item.url"
                style="background-color: #000; border-radius: 4px; max-height: 180px;">
                抱歉，您的浏览器不支持内嵌视频播放。
              </video>
              <a-alert v-else :message="item.name + '视频 URL 缺失'" type="warning" show-icon style="margin-top: 8px;" />
            </div>
          </div>

        </div>

        <a-divider style="margin: 12px 0;" />

        <h4>🔁 循环视频预览</h4>

        <div
          style="max-width: 640px; border: 1px solid #f0f0f0; padding: 10px; border-radius: 4px; background: #fff;">
          <div style="margin-bottom: 8px; display: flex; justify-content: space-between; align-items: center;">
            <div style="flex: 1; min-width: 0; margin-right: 8px;">
              <span style="font-weight: bold; margin-right: 4px;">循环视频:</span>
              <span :title="selectedNode.loopVideo"
                style="font-size: 12px; color: #666; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                <!-- {{ selectedNode.loopVideo }} -->
              </span>
            </div>

            <a-upload name="file" :showUploadList="false" :customRequest="() => { }"
              @change="(info) => handleLanguageVideoUpload(info, 'loopVideo', selectedNode.id)">
              <a-button type="primary" size="small">
                <a-icon type="upload" /> 重新上传
              </a-button>
            </a-upload>
          </div>

          <div style="width: 100%;">
            <video v-if="selectedNode.loopVideo" controls width="100%" height="auto" :src="selectedNode.loopVideo"
              style="background-color: #000; border-radius: 4px; max-height: 180px;">
              抱歉，您的浏览器不支持内嵌视频播放。
            </video>
            <a-alert v-else message="循环视频 URL 缺失" type="warning" show-icon style="margin-top: 8px;" />
          </div>
        </div>

        <a-divider />

        <h4>分支选项（Options）</h4>
        <a-list bordered :dataSource="options" style="max-height:340px;overflow:auto">
          <template slot="renderItem" slot-scope="opt">
            <a-list-item>
              <div style="display:flex;justify-content:space-between;width:100%">
                <div>{{ opt.optionName }} → 节点 {{ opt.nextNodeId }} ({{ getNodeName(opt.nextNodeId) }})</div>
                <a-button type="link" size="small" @click="deleteOption(opt.id)">删除</a-button>
                <a-button type="link" size="small" @click="updateOption(opt.id)">修改</a-button>
              </div>
            </a-list-item>
          </template>
        </a-list>

        <div style="margin-top:8px">
          <a-button type="dashed" @click="openNewOptionModal">新增分支选项</a-button>
        </div>
      </div>
    </a-card>

    <a-modal v-model="nodeModalVisible" title="节点" :confirmLoading="nodeSaving" @ok="saveNode" width="600px">
      <a-form layout="vertical">
        <a-divider orientation="left">基本信息</a-divider>
        <a-form-item label="节点名称">
          <a-input v-model="nodeForm.nodeName" />
        </a-form-item>

        <a-form-item>
          <a-checkbox v-model="nodeForm.isStart">起始节点</a-checkbox>
        </a-form-item>

        <a-form-item label="下一节点（线性，不是分支）">
          <a-select v-model="nodeForm.nextNodeId" allowClear placeholder="选择下一节点(可为空)">
            <a-select-option v-for="node in nodes" :key="node.id" :value="node.id"
              :disabled="isNextNodeDisabledByContext(nodeForm.id, nodeForm.nextNodeId, node.id)">
              {{ node.id }} - {{ node.nodeName }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-divider orientation="left">多语言视频上传</a-divider>

        <a-form-item label="视频" prop="videoUrl">
          <a-upload listType="picture-card" accept=".mp4" class="avatar-uploader" :showUploadList="false"
            :customRequest="handleVideo">
            <div v-if="nodeForm.videoUrl">
              <video :src="nodeForm.videoUrl" width="300" height="150" controls></video>
            </div>
            <div v-else>
              <a-icon :type="uploadLoading ? 'loading' : 'plus'" />
              <div class="ant-upload-text">上传</div>
            </div>
          </a-upload>
          <a-progress style="margin-top: 10px;margin-bottom: 10px;width: 20%" v-if="uploadSize != 0"
            :percent="uploadSize" />
        </a-form-item>

        <a-form-item label="英文视频" prop="videoUrlEn">
          <a-upload listType="picture-card" accept=".mp4" class="avatar-uploader" :showUploadList="false"
            :customRequest="handleVideoEn">
            <div v-if="nodeForm.videoUrlEn">
              <video :src="nodeForm.videoUrlEn" width="300" height="150" controls></video>
            </div>
            <div v-else>
              <a-icon :type="uploadLoadingEn ? 'loading' : 'plus'" />
              <div class="ant-upload-text">上传</div>
            </div>
          </a-upload>
          <a-progress style="margin-top: 10px;margin-bottom: 10px;width: 20%" v-if="uploadEnSize != 0"
            :percent="uploadEnSize" />
        </a-form-item>

        <a-form-item label="日语视频" prop="videoUrlJa">
          <a-upload listType="picture-card" accept=".mp4" class="avatar-uploader" :showUploadList="false"
            :customRequest="handleVideoJa">
            <div v-if="nodeForm.videoUrlJa">
              <video :src="nodeForm.videoUrlJa" width="300" height="150" controls></video>
            </div>
            <div v-else>
              <a-icon :type="uploadLoadingJa ? 'loading' : 'plus'" />
              <div class="ant-upload-text">上传</div>
            </div>
          </a-upload>
          <a-progress style="margin-top: 10px;margin-bottom: 10px;width: 20%" v-if="uploadJaSize != 0"
            :percent="uploadJaSize" />
        </a-form-item>

        <a-form-item label="印尼视频" prop="videoUrlId">
          <a-upload listType="picture-card" accept=".mp4" class="avatar-uploader" :showUploadList="false"
            :customRequest="handleVideoId">
            <div v-if="nodeForm.videoUrlId">
              <video :src="nodeForm.videoUrlId" width="300" height="150" controls></video>
            </div>
            <div v-else>
              <a-icon :type="uploadLoadingId ? 'loading' : 'plus'" />
              <div class="ant-upload-text">上传</div>
            </div>
          </a-upload>
          <a-progress style="margin-top: 10px;margin-bottom: 10px;width: 20%" v-if="uploadIdSize != 0"
            :percent="uploadIdSize" />
        </a-form-item>

        <a-form-item label="葡语视频" prop="videoUrlPt">
          <a-upload listType="picture-card" accept=".mp4" class="avatar-uploader" :showUploadList="false"
            :customRequest="handleVideoPt">
            <div v-if="nodeForm.videoUrlPt">
              <video :src="nodeForm.videoUrlPt" width="300" height="150" controls></video>
            </div>
            <div v-else>
              <a-icon :type="uploadLoadingPt ? 'loading' : 'plus'" />
              <div class="ant-upload-text">上传</div>
            </div>
          </a-upload>
          <a-progress style="margin-top: 10px;margin-bottom: 10px;width: 20%" v-if="uploadPtSize != 0"
            :percent="uploadPtSize" />
        </a-form-item>

        <a-form-item label="西语视频" prop="videoUrlEs">
          <a-upload listType="picture-card" accept=".mp4" class="avatar-uploader" :showUploadList="false"
            :customRequest="handleVideoEs">
            <div v-if="nodeForm.videoUrlEs">
              <video :src="nodeForm.videoUrlEs" width="300" height="150" controls></video>
            </div>
            <div v-else>
              <a-icon :type="uploadLoadingEs ? 'loading' : 'plus'" />
              <div class="ant-upload-text">上传</div>
            </div>
          </a-upload>
          <a-progress style="margin-top: 10px;margin-bottom: 10px;width: 20%" v-if="uploadEsSize != 0"
            :percent="uploadEsSize" />
        </a-form-item>

      </a-form>
    </a-modal>

    <a-modal v-model="optModalVisible" title="新增分支" :confirmLoading="optSaving" @ok="saveOption">
      <a-form layout="vertical">
        <a-form-item label="选项名称">
          <a-input v-model="optForm.optionName" />
        </a-form-item>
                <a-form-item label="选项名称英文">
          <a-input v-model="optForm.optionNameEn" placeholder="请输入英文分支选项名称" />
        </a-form-item>

        <a-form-item label="选项名称日语">
          <a-input v-model="optForm.optionNameJa" placeholder="请输入日文分支选项名称" />
        </a-form-item>

        <a-form-item label="选项名称印尼">
          <a-input v-model="optForm.optionNameId" placeholder="请输入印尼文分支选项名称" />
        </a-form-item>

        <a-form-item label="选项名称葡语">
          <a-input v-model="optForm.optionNamePt" placeholder="请输入葡萄牙文分支选项名称" />
        </a-form-item>

        <a-form-item label="选项名称西语">
          <a-input v-model="optForm.optionNameEs" placeholder="请输入西班牙文分支选项名称" />
        </a-form-item>
        <!-- 
        <a-form-item label="是否默认" prop="isDefault">
          <a-select v-model="optForm.isDefault" placeholder="请选择是否默认" allow-clear>
            <a-select-option value="0">否</a-select-option>
            <a-select-option value="1">是</a-select-option>
          </a-select>
        </a-form-item> -->

        <a-form-item label="分支类型">
          <a-select v-model="optForm.type" placeholder="选择分支类型">
            <a-select-option value="1">分支</a-select-option>
            <a-select-option value="2">补充</a-select-option>
            <a-select-option value="3">风味</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="播放完毕是否回到上一个节点" prop="backToPrevOnEnd">
          <a-select v-model="optForm.backToPrevOnEnd" placeholder="请选择是否回到上一个节点" allow-clear>
            <a-select-option value="0">否</a-select-option>
            <a-select-option value="1">是</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="跳转节点ID">
          <a-select v-model="optForm.nextNodeId" show-search option-filter-prop="children" placeholder="选择下一个节点">
            <a-select-option v-for="node in nodes" :key="node.id" :value="node.id">
              {{ node.nodeName }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="价格">
          <a-input-number v-model="optForm.price" :min="0" />
        </a-form-item>
      </a-form>
    </a-modal>

    <a-modal title="修改分支选项" :visible="isOptionModalVisible" :confirmLoading="loading" @ok="handleOptionModalOk"
      @cancel="handleOptionModalCancel">
      <a-form :form="form" layout="vertical">

        <a-form-item label="选项名称">
          <a-input v-model="optForm.optionName" placeholder="请输入分支选项名称" />
        </a-form-item>
        <a-form-item label="选项名称英文">
          <a-input v-model="optForm.optionNameEn" placeholder="请输入英文分支选项名称" />
        </a-form-item>

        <a-form-item label="选项名称日语">
          <a-input v-model="optForm.optionNameJa" placeholder="请输入日文分支选项名称" />
        </a-form-item>

        <a-form-item label="选项名称印尼">
          <a-input v-model="optForm.optionNameId" placeholder="请输入印尼文分支选项名称" />
        </a-form-item>

        <a-form-item label="选项名称葡语">
          <a-input v-model="optForm.optionNamePt" placeholder="请输入葡萄牙文分支选项名称" />
        </a-form-item>

        <a-form-item label="选项名称西语">
          <a-input v-model="optForm.optionNameEs" placeholder="请输入西班牙文分支选项名称" />
        </a-form-item>

        <!-- <a-form-item label="是否默认">
          <a-select v-model="optForm.isDefault" placeholder="请选择是否默认" allow-clear>
            <a-select-option :value="0">否</a-select-option>
            <a-select-option :value="1">是</a-select-option>
          </a-select>
        </a-form-item> -->

        <a-form-item label="播放完毕是否回到上一个节点" prop="backToPrevOnEnd">
          <a-select v-model="optForm.backToPrevOnEnd" placeholder="请选择是否回到上一个节点" allow-clear>
            <a-select-option value="0">否</a-select-option>
            <a-select-option value="1">是</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="分支类型">
          <a-select v-model="optForm.type" placeholder="选择分支类型">
            <a-select-option :value="1">分支</a-select-option>
            <a-select-option :value="2">补充</a-select-option>
            <a-select-option :value="3">风味</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="跳转节点ID">
          <a-select v-model="optForm.nextNodeId" show-search option-filter-prop="children" allowClear
            placeholder="选择下一个节点 (留空表示结束)">
            <a-select-option v-for="node in selectableNodes" :key="node.id" :value="node.id">
              {{ node.nodeName }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="价格">
          <a-input-number v-model="optForm.price" :min="0" style="width: 100%;" />
        </a-form-item>

      </a-form>
    </a-modal>

    <a-modal v-model="batchModalVisible" title="批量上传节点视频" :confirmLoading="batchUploading" @ok="submitBatchUpload"
      width="700px">
      <div style="margin-bottom: 16px; padding: 12px; background: #fffbe6; border: 1px solid #ffe58f;">
        <p>💡 **批量上传命名规范：**</p>
        <p>请将文件名命名为： `[节点名称或ID]_[语言代码].mp4`</p>
        <p>示例： `Node_123_zh.mp4`,`Node_123_en.mp4`, `Node_123_ja.mp4`</p>
        <p>支持的语言代码： `zh` (主视频), `en`, `ja`, `id`, `pt`, `es`</p>
      </div>

      <a-upload-dragger :customRequest="handleBatchUpload" :multiple="true" accept=".mp4" :file-list="batchFileList"
        @remove="(file) => { batchFileList = batchFileList.filter(f => f.uid !== file.uid); }">
        <p class="ant-upload-drag-icon">
          <a-icon type="inbox" />
        </p>
        <p class="ant-upload-text">点击或拖拽文件到此区域进行批量上传</p>
        <p class="ant-upload-hint">支持多个 MP4 文件，请确保文件名符合规范</p>
      </a-upload-dragger>

      <a-list v-if="batchFileList.length > 0" :dataSource="batchFileList" size="small"
        style="margin-top: 16px; max-height: 200px; overflow: auto;" header="已选择文件列表">
        <a-list-item slot="renderItem" slot-scope="item">
          {{ item.name }}
          <a-tag v-if="item.matchedNode && item.matchedLang" color="blue" slot="actions">
            匹配: {{ item.matchedNode }} ({{ item.matchedLang }})
          </a-tag>
          <a-tag v-else color="red" slot="actions">
            未匹配或命名错误
          </a-tag>
        </a-list-item>
      </a-list>

      <a-progress v-if="batchUploading" :percent="batchUploadProgress" style="margin-top: 16px;" />
    </a-modal>
  </div>
</template>

<script>
import { Modal, message } from 'ant-design-vue'
import {
  listBranchNode,
  addBranchNode,
  updateBranchNode,
  delBranchNode,
  listBranchOption,
  addBranchOption,
  updateBranchOption,
  optionDetail,
  delBranchOption,
  batchUpsertNodeVideos
} from '@/api/branch/branch'
import UploadFileToVOD from "@/api/vod.js"
import NodeVisualModal from './NodeVisualModal.vue';

export default {
  name: 'InteractiveBranchEditor',
  props: {
    videoId: {
      type: [String, Number],
      default: null,
      required: true
    }
  },
  components: {
    NodeVisualModal
  },
  data() {
    return {
      visualVisible: false,
      nodes: [],
      // treeData: [], // 替换 organizedNodes，用于 a-tree
      nodeMap: {}, // 用于快速查找节点的 Map {id: node}
      selectedNode: null,
      options: [],
      isOptionModalVisible: false,
      nodeModalVisible: false,
      optModalVisible: false,
      nodeSaving: false,
      optSaving: false,

      batchModalVisible: false,
      batchFileList: [],
      batchUploading: false,
      batchUploadProgress: 0,
      batchMatchResults: null, // 用于存储匹配成功的节点和语言信息
      isNameEditing: false, // 🌟 新增：控制节点名称是否处于编辑状态
      editingNodeName: '',  // 🌟 新增：用于存储编辑中的临时名称
      nodeForm: {
        id: null,
        videoId: null,
        nodeName: '',
        videoUrl: '',
        videoUrlEn: '', // 新增
        videoUrlJa: '', // 新增
        videoUrlId: '', // 新增
        videoUrlPt: '', // 新增
        videoUrlEs: '', // 新增
        isStart: false,
        nextNodeId: null
      },
      optForm: {
        id: null,
        videoId: null,
        preNodeId: null,
        nextNodeId: null,
        optionName: '',
        optionNameEn: '',
        optionNameJa: '',
        optionNameId: '',
        optionNamePt: '',
        optionNameEs: '',
        price: 0,
        type: 3,
        isDefault: 0,
        backToPrevOnEnd: 0
      },
      uploadLoading: false,
      uploadLoadingEn: false,
      uploadLoadingJa: false,
      uploadLoadingId: false,
      uploadLoadingPt: false,
      uploadLoadingEs: false,

      uploadSize: 0,
      uploadEnSize: 0,
      uploadJaSize: 0,
      uploadIdSize: 0,
      uploadPtSize: 0,
      uploadEsSize: 0,
    }
  },
  mounted() {
    if (this.videoId) {
      this.loadNodes();
    }
  },
  // 在您的 Vue 组件 (export default) 的 computed 属性中
  computed: {
    // 封装所有语言URL及其名称的映射
    getLangUrls() {
      if (!this.selectedNode) {
        return {};
      }
      return {
        'videoUrl': { name: '中文', url: this.selectedNode.videoUrl, id: this.selectedNode.id },
        'videoUrlEn': { name: '英文', url: this.selectedNode.videoUrlEn, id: this.selectedNode.id },
        'videoUrlJa': { name: '日语', url: this.selectedNode.videoUrlJa, id: this.selectedNode.id },
        'videoUrlId': { name: '印尼语', url: this.selectedNode.videoUrlId, id: this.selectedNode.id },
        'videoUrlPt': { name: '葡语', url: this.selectedNode.videoUrlPt, id: this.selectedNode.id },
        'videoUrlEs': { name: '西语', url: this.selectedNode.videoUrlEs, id: this.selectedNode.id },
      };
    },
    /**
     * 反向引用索引：记录每个节点被哪些节点“指向/绑定”
     * key: 被引用的 nodeId (string), value: 引用它的 fromNodeId 数组
     * 用于禁选“已经被绑定过”的节点，避免树 key 重复/循环导致崩溃
     */
    incomingRefMap() {
      const incoming = {};
      const nodes = this.nodes || [];
      const add = (toId, fromId) => {
        if (toId === null || toId === undefined || toId === '') return;
        const key = String(toId);
        if (!incoming[key]) incoming[key] = [];
        incoming[key].push(fromId);
      };

      nodes.forEach(n => {
        add(n.nextNodeId, n.id);
        if (Array.isArray(n.options)) {
          n.options.forEach(opt => add(opt.nextNodeId, n.id));
        }
      });

      // 分支选项有时是单独加载到 this.options 的（而不是挂在 nodes[i].options 上）
      // 为了让“已绑定”禁选在右侧面板/弹窗里保持一致，这里也把当前已加载的 options 纳入统计
      if (this.selectedNode && Array.isArray(this.options) && this.options.length > 0) {
        this.options.forEach(opt => add(opt.nextNodeId, this.selectedNode.id));
      }

      return incoming;
    },
    treeData() {
      if (!this.nodes || this.nodes.length === 0) return [];

      const nodeMap = this.nodes.reduce((map, node) => {
        map[node.id] = node;
        return map;
      }, {});

      // 1. 查找起始节点
      const rootNode = this.nodes.find(n => n.isStart);
      let resultTree = [];

      // 2. 构建主流程树
      if (rootNode) {
        const builtRoot = this.buildTree(rootNode.id, nodeMap);
        if (builtRoot) {
          resultTree.push(builtRoot);
        }
      }

      // 3. 找出所有被引用的节点 ID
      // 孤立节点是：既不是起始节点，又没有被任何节点引用的节点。
      const referencedIds = this.getReferencedNodes(this.nodes);

      // 4. 遍历所有节点，查找孤立节点
      this.nodes.forEach(node => {
        // 排除：1. 起始节点（已在主流程中），2. 已被引用的节点（已在主流程中），3. 已在结果树中的节点 (通过 resultTree.some 检查 key/id)
        const isRootNode = rootNode && node.id === rootNode.id;
        const isReferenced = referencedIds.has(node.id);
        const isAlreadyInTree = resultTree.some(root => root.key === node.id);

        if (!isRootNode && !isReferenced && !isAlreadyInTree) {
          // 这是一个孤立节点，将其作为一个新的根节点加入列表
          // 注意：孤立节点本身也必须通过 buildTree 格式化，但它的 children 应该是空的
          const orphanTree = {
            title: node.nodeName || '节点 ' + node.id,
            key: node.id,
            ...node,
            children: [] // 孤立节点没有下游
          };
          resultTree.push(orphanTree);
          console.warn(`[Tree Node] 发现孤立节点: ${node.nodeName} (${node.id})`);
        }
      });

      return resultTree;
    },
  },
  watch: {
    nodes: {
      handler() {
      },
      deep: true
    }
  },
  methods: {
    async updateOption(optionId) {
      if (!this.selectedNode) {
        return this.$message.error('请先选择节点');
      }
      this.loading = true;

      try {
        const queryPayload = { optionId: optionId };

        const res = await optionDetail(queryPayload);

        const optionDetailData = res.data;

        if (!optionDetailData || !optionDetailData.id) {
          this.$message.error('后端未返回有效的分支选项数据。');
          return;
        }

        this.optForm = JSON.parse(JSON.stringify(optionDetailData));


        this.selectableNodes = this.nodes.filter(n => n.id !== this.selectedNode.id);

        this.isOptionModalVisible = true;

      } catch (e) {
        this.$message.error(`获取分支选项详情失败: ${e.message || '未知错误'}`);
      } finally {
        this.loading = false;
      }
    },
    async handleOptionModalOk() {
      const { id, optionName, nextNodeId, price, type, isDefault, backToPrevOnEnd, optionNameEn, optionNameJa, optionNameId, optionNamePt, optionNameEs, } = this.optForm;

      if (!optionName.trim()) {
        return this.$message.error('选项名称不能为空');
      }

      const updatePayload = {
        id: id,
        optionName: optionName.trim(),
        nextNodeId: nextNodeId,
        isDefault: isDefault,
        backToPrevOnEnd: backToPrevOnEnd,
        price: price,
        type: type,
        optionNameEn: optionNameEn,
        optionNameJa: optionNameJa,
        optionNameId: optionNameId,
        optionNamePt: optionNamePt,
        optionNameEs: optionNameEs,
      };

      try {
        await updateBranchOption(updatePayload);
        this.$message.success('分支选项更新成功');

        // 2. 更新成功后，关闭模态框并刷新数据
        this.isOptionModalVisible = false;
        // 刷新节点列表，确保树形图和描述面板同步
        this.loadNodes();

      } catch (e) {
        this.$message.error(`更新失败: ${e.message || '未知错误'}`);
      }
    },
    handleOptionModalCancel() {
      this.isOptionModalVisible = false;
    },
    startNameEdit() {
      this.editingNodeName = this.selectedNode.nodeName;
      this.isNameEditing = true;
      this.$nextTick(() => {
        if (this.$refs.nameInput) {
          this.$refs.nameInput.focus();
        }
      });
    },

    async submitNameEdit() {
      const originalNodeName = this.selectedNode.nodeName;
      const newName = this.editingNodeName.trim();
      const nextNodeId = this.selectedNode.nextNodeId;
      // 1. 验证输入
      if (!newName) {
        this.$message.error('节点名称不能为空！');
        return;
      }

      this.$set(this.selectedNode, 'nodeName', newName);

      try {
        await this.updateNodeName(this.selectedNode.id, newName, nextNodeId);

        this.isNameEditing = false;

      } catch (e) {
        this.$message.error('节点名称更新失败，已恢复原值。');
        this.$set(this.selectedNode, 'nodeName', originalNodeName);

        this.isNameEditing = true;
      }
    },
    updateNodeName(nodeId, newName, nextNodeId) {
      // 1. 构造只包含 ID 和需更新字段的参数对象
      const params = {
        id: nodeId, // 数据库主键 ID
        // 动态设置要更新的字段及其值
        nodeName: newName,
        nextNodeId: nextNodeId
      };

      // 2. 调用已导入的 updateBranchNode API
      updateBranchNode(params).then(res => {
        if (res.code === '20001') {
          this.$message.success(`保存成功！`);
        } else {
          this.$message.error(` 保存失败: ${res.message || '服务器错误'}`);
        }
      }).catch(e => {
        console.error('更新节点 URL 请求失败:', e);
        this.$message.error(`${langName} URL 保存请求失败。`);
      });
    },
    // 取消编辑
    cancelNameEdit() {
      this.isNameEditing = false;
      this.editingNodeName = '';
    },
    getReferencedNodes(nodes) {
      const referencedIds = new Set();

      nodes.forEach(node => {
        // 1. 检查线性流引用
        if (node.nextNodeId) {
          referencedIds.add(node.nextNodeId);
        }

        // 2. 检查分支选项引用
        if (node.options && node.options.length > 0) {
          node.options.forEach(opt => {
            if (opt.nextNodeId) {
              referencedIds.add(opt.nextNodeId);
            }
          });
        }
      });

      return referencedIds;
    },
    buildTree(nodeId, nodeMap, path = new Set()) {
      // ✅ 循环引用保护：避免错误配置导致无限递归、树直接崩溃
      if (path.has(nodeId)) {
        const currentNode = nodeMap[nodeId];
        console.warn(`[Tree Warning] 检测到循环引用，节点 ${nodeId} 已在当前路径中。将截断该分支以避免崩溃。`);
        if (!currentNode) return null;
        return {
          title: (currentNode.nodeName || ('节点 ' + currentNode.id)) + ' (循环引用)',
          key: currentNode.id,
          ...currentNode,
          children: []
        };
      }

      // 🌟 关键检查 1: 确保当前 ID 对应的节点存在于 Map 中
      const currentNode = nodeMap[nodeId];
      if (!currentNode) {
        // 可能是数据错误或循环引用中断
        console.error(`[Tree Build Error] 节点ID ${nodeId} 在 nodeMap 中不存在，可能存在悬空链接。`);
        return null;
      }

      const nextPath = new Set(path);
      nextPath.add(nodeId);

      const treeNode = {
        title: currentNode.nodeName || '节点 ' + currentNode.id,
        key: currentNode.id,
        // 将整个 InteractiveResult 对象合并到 treeNode 中
        ...currentNode,
        children: []
      };

      const childrenNodes = new Map();

      // 1. 处理分支选项 (Options)
      if (currentNode.options && currentNode.options.length > 0) {
        currentNode.options.forEach(opt => {
          const nextId = opt.nextNodeId;

          // 🌟 关键检查 2: 确保分支指向的下一个 ID 存在于 Map 中
          if (nextId && nodeMap[nextId] && !childrenNodes.has(nextId)) {
            const childTree = this.buildTree(nextId, nodeMap, nextPath);
            if (childTree) {
              childrenNodes.set(nextId, childTree);
            }
          } else if (nextId && !nodeMap[nextId]) {
            console.warn(`[Tree Warning] 节点 ${currentNode.id} 的分支选项指向了不存在的节点 ID: ${nextId}。该分支将被跳过。`);
          }
        });
      }

      // 2. 处理线性流 (nextNodeId)
      // 🌟 修正：将原有的 'else if' 更改为独立的 'if' 语句。
      // 这确保了即使节点有分支选项 (if 1 成立)，也会继续检查线性流。
      if (currentNode.nextNodeId) {
        const nextId = currentNode.nextNodeId;

        // 🌟 关键检查 3: 确保线性指向的下一个 ID 存在于 Map 中，且没有被分支重复添加
        if (nextId !== currentNode.id && nodeMap[nextId] && !childrenNodes.has(nextId)) {
          const childTree = this.buildTree(nextId, nodeMap, nextPath);
          if (childTree) {
            // 将线性子节点也加入列表
            childrenNodes.set(nextId, childTree);
            console.warn(`[Tree Note] 节点 ${currentNode.id} 同时具有分支和线性流 (${nextId})。`);
          }
        } else if (nextId && !nodeMap[nextId]) {
          console.warn(`[Tree Warning] 节点 ${currentNode.id} 的线性流指向了不存在的节点 ID: ${nextId}。该链接将被跳过。`);
        }
      }

      // 将 Map 转换为数组并赋值给 children
      treeNode.children = Array.from(childrenNodes.values());

      return treeNode;
    },
    handleLanguageVideoUpload(info, fieldName, id) {
      console.log('进来id', id)
      const file = (info && info.file && (info.file.originFileObj || info.file)) || null;
      // if (file.status === 'uploading') {
      //   this.uploadLoading = true;
      //   return;
      // }
      console.log('bbbbbbbbb')
      if (!file) return;
      let that = this;
      that.uploadLoading = true;

      new UploadFileToVOD([file], {
        success: function (videoUrlList) {
          console.log('ccccccccs')
          const url = videoUrlList[0];
          that.uploadLoading = false;

          // 直接回填到当前选中节点（预览区）
          if (that.selectedNode) {
            that.$set(that.selectedNode, fieldName, url);
          }

          console.log('id', id, fieldName)
          that.saveUrlToDatabase(id, fieldName, url);
        },
        vProgress: function (val) {
          that.uploadSize = val * 100;
        }
      });
    },

    saveUrlToDatabase(nodeId, fieldName, videoUrl) {
      // 1. 构造只包含 ID 和需更新字段的参数对象
      const params = {
        id: nodeId, // 数据库主键 ID
        // 动态设置要更新的字段及其值
        [fieldName]: videoUrl
      };

      // 2. 调用已导入的 updateBranchNode API
      updateBranchNode(params).then(res => {
        if (res.code === '20001') {
          this.$message.success(`保存成功！`);
        } else {
          this.$message.error(` 保存失败: ${res.message || '服务器错误'}`);
        }
      }).catch(e => {
        console.error('更新节点 URL 请求失败:', e);
        this.$message.error(`${fieldName} URL 保存请求失败。`);
      });
    },
    /** 实时更新当前选中节点的 nextNodeId */
    async updateNextNodeId(newNextNodeId) {
      if (!this.selectedNode) {
        return message.error('请先选择一个节点');
      }

      // ✅ 禁止选择“已被绑定过”的节点或会形成循环的节点（兜底校验，避免绕过禁用项）
      if (newNextNodeId && this.isNextNodeDisabledByContext(this.selectedNode.id, this.selectedNode.nextNodeId, newNextNodeId)) {
        return message.error('该节点已被其他节点绑定或会形成循环引用，请选择其他节点');
      }

      this.selectedNode.nextNodeId = newNextNodeId;

      const updatePayload = {
        id: this.selectedNode.id,
        videoId: this.selectedNode.videoId,
        nextNodeId: newNextNodeId
      };

      try {
        await updateBranchNode(updatePayload);
        message.success('下一节点更新成功');

        this.loadNodes();

      } catch (e) {
        message.error(`更新失败: ${e.message || '未知错误'}`);
        this.selectedNode.nextNodeId = null;
      }
    },

    /**
     * 下一节点禁用规则：
     * - 不能选择自己
     * - 不能选择已被其他节点引用/绑定的节点（避免同一个节点出现在树上多个位置导致 key 冲突）
     * - 不能选择会造成循环引用的节点（避免 buildTree 无限递归）
     */
    isNextNodeDisabledByContext(currentId, currentNextNodeId, candidateId) {
      if (candidateId === null || candidateId === undefined || candidateId === '') return false;

      const currentKey = (currentId === null || currentId === undefined || currentId === '') ? null : String(currentId);
      const candKey = String(candidateId);
      const currentNextKey = (currentNextNodeId === null || currentNextNodeId === undefined || currentNextNodeId === '') ? null : String(currentNextNodeId);

      // 不能选择自己
      if (currentKey && candKey === currentKey) return true;

      const incomingFrom = this.incomingRefMap[candKey] || [];

      // 统一口径：只要候选节点已被任何地方引用/绑定，就禁用
      // 但允许保留当前已有选择（避免历史脏数据导致无法打开/无法保持现状）
      const isReferenced = incomingFrom.length > 0;
      if (isReferenced && (!currentNextKey || candKey !== currentNextKey)) return true;

      // 循环引用检测：如果 candidate -> ... -> current 有路径，设置 current.next = candidate 将形成环
      if (currentKey && this.wouldCreateCycle(currentId, candidateId)) return true;

      return false;
    },

    wouldCreateCycle(fromId, toId) {
      if (!fromId || !toId) return false;

      const startKey = String(toId);
      const targetKey = String(fromId);

      // 构造邻接表（包含 options + nextNodeId），并把 fromId 的 nextNodeId 临时视为 toId
      const adj = {};
      const nodes = this.nodes || [];

      const addEdge = (from, to) => {
        if (to === null || to === undefined || to === '') return;
        const k = String(from);
        if (!adj[k]) adj[k] = [];
        adj[k].push(to);
      };

      nodes.forEach(n => {
        const next = (n.id === fromId) ? toId : n.nextNodeId;
        addEdge(n.id, next);

        if (Array.isArray(n.options)) {
          n.options.forEach(opt => addEdge(n.id, opt.nextNodeId));
        }
      });

      // BFS：从 toId 出发能否到达 fromId
      const queue = [startKey];
      const visited = new Set();

      while (queue.length) {
        const curKey = queue.shift();
        if (curKey === targetKey) return true;
        if (visited.has(curKey)) continue;
        visited.add(curKey);

        const neighbors = adj[curKey] || [];
        neighbors.forEach(nxt => {
          const nxtKey = String(nxt);
          if (!visited.has(nxtKey)) queue.push(nxtKey);
        });
      }

      return false;
    },
    openBatchUploadModal() {
      if (!this.videoId) {
        return message.warning('无法加载，videoId 缺失')
      }

      this.batchFileList = []
      this.batchUploadProgress = 0
      this.batchMatchResults = null
      this.batchModalVisible = true
    },

    /** 2. 自定义批量上传处理 */
    handleBatchUpload(data) {
      const file = data.file;

      // 修正后的正则表达式：
      // 1. (.+?)：节点名 (如 'node1')
      // 2. _：下划线分隔符
      // 3. (\w{2})：两位的语言代码 (如 'zh', 'en')
      // 4. \.mp4$：文件后缀必须是 .mp4 并且是文件结尾
      const regex = /(.+)_(zh|en|ja|id|pt|es)\.mp4$/i;
      const match = file.name.match(regex);

      let nodeIdOrName = null;
      let langCode = null;

      if (match) {
        nodeIdOrName = match[1]; // 匹配到 'node1'
        langCode = match[2].toLowerCase(); // 匹配到 'zh'

        // 确保语言代码是小写的，但正则已经做了不区分大小写

        // ⚠️ 增加一个额外的安全检查，确保 langCode 在有效列表内
        const validLangs = ['zh', 'en', 'ja', 'id', 'pt', 'es'];
        if (!validLangs.includes(langCode)) {
          message.warning(`文件 ${file.name} 语言代码 ${langCode} 无效。`);
          nodeIdOrName = null; // 置空，防止进入上传队列
          langCode = null;
        }
      } else {
        // 如果不符合规范，仍然加入列表，但标记为待定
        message.warning(`文件 ${file.name} 命名不规范，无法自动识别节点或语言。请使用 [节点名]_[语言代码].mp4 格式。`);
      }

      this.batchFileList.push({
        uid: file.uid,
        name: file.name,
        status: 'ready',
        file: file,
        matchedNode: nodeIdOrName, // 匹配到的节点信息 ('node1')
        matchedLang: langCode, // 匹配到的语言代码 ('zh')
      });
    },

    /** 3. 提交批量上传 */
    async submitBatchUpload() {
      if (this.batchFileList.length === 0) {
        return message.warning('请先选择文件');
      }

      const filesToUpload = this.batchFileList.filter(f => f.matchedNode && f.matchedLang);

      if (filesToUpload.length === 0) {
        return message.error('没有匹配到任何符合命名规范的视频文件，请检查文件名。');
      }

      this.batchUploading = true;
      this.batchUploadProgress = 0;

      try {
        const uploadMap = filesToUpload.map(f => ({
          fileName: f.name,
          nodeIdOrName: f.matchedNode,
          langCode: f.matchedLang,
          file: f.file
        }));
        console.log('--- 批量上传准备 Map (uploadMap) ---');
        console.log(uploadMap);
        console.log('-------------------------------------');
        const totalFiles = uploadMap.length;
        const successUrls = [];
        let uploadedCount = 0;

        // 将每个文件的 VOD 上传封装成一个 Promise
        const uploadPromises = uploadMap.map(item => {
          return new Promise(resolve => {
            new UploadFileToVOD([item.file], {
              success: (urlList) => {
                successUrls.push({
                  nodeIdOrName: item.nodeIdOrName,
                  langCode: item.langCode,
                  url: urlList[0]
                });
                uploadedCount++;
                // 更新总进度：已完成的文件数 / 总文件数
                this.batchUploadProgress = Math.floor((uploadedCount / totalFiles) * 100);
                resolve(); // VOD 上传成功，Promise 完成
              },
              vProgress: (val) => {
                // 忽略单个文件的进度，只更新总进度
              },
              error: () => {
                message.error(`文件 ${item.fileName} 上传到 VOD 失败，跳过更新。`);
                uploadedCount++;
                this.batchUploadProgress = Math.floor((uploadedCount / totalFiles) * 100);
                resolve(); // 即使失败也要 resolve，保证 Promise.all 继续
              }
            });
          });
        });

        // 等待所有文件上传完成 (并行执行)
        await Promise.all(uploadPromises);

        // 确保进度条显示 100%
        this.batchUploadProgress = 100;
        console.log('--- VOD 上传成功 URL 列表 (successUrls) ---');
        console.log(successUrls);
        console.log('--------------------------------------------');
        if (successUrls.length === 0) {
          return message.error('所有文件上传到 VOD 均失败，无法更新节点。');
        }

        // --- 第 2 步：调用批量更新 API ---
        await this.batchUpdateNodes(successUrls);

        message.success('所有视频批量上传和更新成功！');
        this.batchModalVisible = false;
        this.loadNodes(); // 重新加载节点数据

      } catch (e) {
        message.error(`批量上传过程中发生错误: ${e.message || '未知错误'}`);
      } finally {
        this.batchUploading = false;
      }
    },
    /** 4. 批量更新节点的 URL */
    // 4. 批量更新节点的 URL (重构)
    async batchUpdateNodes(successUrls) {
      // successUrls: [{ nodeIdOrName: 'node1', langCode: 'zh', url: 'xxx' }, ...]

      // 1. 创建用于聚合的 Map
      const nodeUpdatesMap = new Map();
      const validLangs = ['zh', 'en', 'ja', 'id', 'pt', 'es'];

      // 遍历所有上传成功的 URL，按 nodeIdOrName (如 'node1') 进行聚合
      successUrls.forEach(item => {
        const identifier = item.nodeIdOrName; // 例如: 'node1'
        const langCode = item.langCode;       // 例如: 'zh'

        if (!validLangs.includes(langCode)) {
          console.warn(`跳过无效语言代码: ${langCode} for ${identifier}`);
          return;
        }

        // 确保 Map 中有当前标识符的条目
        if (!nodeUpdatesMap.has(identifier)) {
          // 初始化 Payload
          nodeUpdatesMap.set(identifier, {
            nodeName: identifier, // 使用标识符作为 nodeName
            // 确保所有字段都有 null 或默认值，以便最终 Payload 结构完整
            videoUrl: null, videoUrlEn: null, videoUrlJa: null,
            videoUrlId: null, videoUrlPt: null, videoUrlEs: null,
          });
        }

        const payload = nodeUpdatesMap.get(identifier);

        // 2. 根据 langCode 映射到正确的字段 (例如 'en' -> 'videoUrlEn')
        let urlKey = 'videoUrl';
        if (langCode !== 'zh') {
          // 构造驼峰命名: en -> En, 然后 'videoUrl' + 'En' = 'videoUrlEn'
          urlKey += langCode.charAt(0).toUpperCase() + langCode.slice(1);
        }

        // 3. 赋值 URL
        payload[urlKey] = item.url;
      });

      // 4. 将 Map 转换为数组
      const nodesToUpdate = Array.from(nodeUpdatesMap.values());

      if (nodesToUpdate.length === 0) {
        throw new Error('没有有效的 URL 用于更新节点。');
      }

      const updatePayload = {
        videoId: this.videoId,
        nodes: nodesToUpdate
      };

      console.log('Final Aggregated Batch Update Payload (发送给后端):', updatePayload);
      message.info(`准备发送 ${updatePayload.nodes.length} 个节点的批量更新请求...`);

      // 5. 调用后端 API
      const res = await batchUpsertNodeVideos(updatePayload);
      console.log('-----------------------', res)
      if (res.code !== "20001") {
        throw new Error(`后端批量更新失败: ${res.msg || '未知错误'}`);
      }
    },
    /** 加载节点列表 */
    // 在 loadNodes 方法内部
    async loadNodes() {
      if (!this.videoId) return message.warning('videoId 缺失，无法加载节点')
      try {
        const res = await listBranchNode({ videoId: this.videoId })
        // 🌟 将扁平数据保存在 nodes 中，触发 computed 自动构建 treeData
        this.nodes = res.data || []

        // 重新加载后，重新选中当前节点以更新右侧面板数据，或默认选中起始节点
        if (this.selectedNode) {
          const reloadedNode = this.nodes.find(n => n.id === this.selectedNode.id);
          if (reloadedNode) {
            this.selectNode(reloadedNode); // 重新加载分支
          } else {
            this.selectedNode = null;
            this.options = [];
          }
        } else {
          const startNode = this.nodes.find(n => n.isStart)
          if (startNode) {
            this.selectNode(startNode);
          }
        }

      } catch (e) {
        message.error('加载节点失败')
      }
    },

    /** 组织节点关系，构建 a-tree 需要的树形结构 */
    // organizeNodes() {
    //   const nodeMap = new Map()
    //   const predecessorMap = new Map() // 用于追踪哪些节点有前驱

    //   // 1. 预处理节点数据，并记录前驱
    //   this.nodes.forEach(node => {
    //     // 构建 a-tree 需要的节点对象
    //     nodeMap.set(node.id, {
    //       ...node,
    //       key: node.id,
    //       title: node.nodeName || `节点 ${node.id}`, // title 用于 a-tree 的插槽
    //       children: []
    //     })

    //     // 记录线性前驱
    //     if (node.nextNodeId) {
    //       predecessorMap.set(node.nextNodeId, true)
    //     }

    //     // ⚠️ 理想情况下，这里也应该记录所有分支选项连接的节点作为前驱，
    //     // 但由于分支选项数据是按需加载的，这里只处理线性和起始节点。
    //   })

    //   // 递归查找子节点（仅根据 nextNodeId 线性关系）
    //   const findChildren = (parentId) => {
    //     const parentNode = nodeMap.get(parentId)
    //     if (!parentNode) return

    //     const nextNodeId = parentNode.nextNodeId

    //     // 线性下一节点
    //     if (nextNodeId && nodeMap.has(nextNodeId)) {
    //       const nextNode = nodeMap.get(nextNodeId)
    //       // 避免重复添加，并防止环形引用导致无限递归
    //       if (!parentNode.children.some(n => n.key === nextNodeId)) {
    //         parentNode.children.push(nextNode)
    //         findChildren(nextNodeId) // 递归继续构建线性链
    //       }
    //     }

    //     // ⚠️ 实际项目中，如果希望分支节点也作为树的子节点展示，
    //     // 你需要在这一步获取所有 BranchOption 的数据，并根据 preNodeId == parentId 
    //     // 找到所有分支目标节点，作为 parentNode.children 添加进来。
    //   }

    //   const treeData = []

    //   // 2. 找到所有根节点 (没有前驱的节点 或 是起始节点)
    //   this.nodes.forEach(node => {
    //     if (!predecessorMap.has(node.id) || node.isStart) {
    //       const rootNode = nodeMap.get(node.id)
    //       // 防止重复添加，特别是在 isStart 和无前驱重合时
    //       if (rootNode && !treeData.some(n => n.key === rootNode.key)) {
    //         treeData.push(rootNode)
    //         findChildren(rootNode.id)
    //       }
    //     }
    //   })

    //   this.treeData = treeData
    // },
    /** 根据节点ID获取节点名称 */
    getNodeName(nodeId) {
      const node = this.nodes.find(n => n.id === nodeId)
      return node ? node.nodeName : '未知节点'
    },

    refresh() {
      this.loadNodes()
    },

    /** 处理 a-tree 节点选择事件 */
    onTreeSelect(selectedKeys, info) {
      // 检查是否有节点被选中
      if (selectedKeys.length > 0 && info.node.dataRef) {
        // info.node.dataRef 存储着我们在 organizeNodes 中构建的原始节点数据
        const node = info.node.dataRef
        this.selectNode(node)
      } else {
        this.selectedNode = null
        this.options = []
      }
    },

    /** 选择节点加载分支 */
    async selectNode(node) {
      this.selectedNode = node
      try {
        // 加载当前节点的选项/分支
        const res = await listBranchOption({ preNodeId: node.id })
        this.options = res.data || []
      } catch (e) {
        message.error('加载分支失败')
      }
    },

    /** 新建节点 */
    openNewNodeModal() {
      // 重置表单为新建状态，包含所有多语言 URL
      this.nodeForm = {
        id: null,
        videoId: this.videoId,
        nodeName: '', // 将由主视频上传填充
        videoUrl: '',
        videoUrlEn: '',
        videoUrlJa: '',
        videoUrlId: '',
        videoUrlPt: '',
        videoUrlEs: '',
        isStart: false,
        nextNodeId: null
      }

      // 重置所有上传状态和进度
      this.uploadLoading = this.uploadLoadingEn = this.uploadLoadingJa = this.uploadLoadingId = this.uploadLoadingPt = this.uploadLoadingEs = false
      this.uploadSize = this.uploadEnSize = this.uploadJaSize = this.uploadIdSize = this.uploadPtSize = this.uploadEsSize = 0

      this.nodeModalVisible = true
    },

    /** 编辑节点 */
    openEditNodeModal() {
      // 拷贝选中节点数据到表单 (包含所有多语言 URL)
      Object.assign(this.nodeForm, this.selectedNode)

      // 编辑时重置上传状态和进度
      this.uploadLoading = this.uploadLoadingEn = this.uploadLoadingJa = this.uploadLoadingId = this.uploadLoadingPt = this.uploadLoadingEs = false
      this.uploadSize = this.uploadEnSize = this.uploadJaSize = this.uploadIdSize = this.uploadPtSize = this.uploadEsSize = 0

      this.nodeModalVisible = true
    },

    /** 保存节点 */
    async saveNode() {
      this.nodeSaving = true
      try {
        // ✅ 兜底：防止在弹窗里选到已绑定/会成环的 nextNodeId
        // 注意：currentNextNodeId 这里要传“保存前旧值”，否则无法正确判断“是否已绑定”
        const oldNextNodeId = this.selectedNode && this.selectedNode.id === this.nodeForm.id ? this.selectedNode.nextNodeId : null
        if (this.nodeForm.nextNodeId && this.isNextNodeDisabledByContext(this.nodeForm.id, oldNextNodeId, this.nodeForm.nextNodeId)) {
          message.error('下一节点已被其他节点绑定或会形成循环引用，请重新选择')
          return
        }

        if (this.nodeForm.id) {
          await updateBranchNode(this.nodeForm)
        } else {
          const res = await addBranchNode(this.nodeForm)
          // 确保新建后能获取到 ID
          this.nodeForm.id = res.data && res.data.id
        }
        message.success('保存成功')
        this.nodeModalVisible = false
        await this.loadNodes()
      } catch (e) {
        message.error('保存失败')
      } finally {
        this.nodeSaving = false
      }
    },

    /** 删除节点 */
    confirmDeleteNode() {
      Modal.confirm({
        title: '确认删除节点？',
        onOk: async () => {
          try {
            await delBranchNode(this.selectedNode.id)
            message.success('删除成功')
            this.loadNodes()
            this.selectedNode = null
            this.options = []
          } catch (e) {
            message.error('删除失败')
          }
        }
      })
    },

    /** 新增分支 */
    openNewOptionModal() {
      if (!this.selectedNode) return message.warning('请先选择节点')
      this.optForm = {
        id: null,
        videoId: this.videoId,
        preNodeId: this.selectedNode.id, // 当前选中节点作为前驱
        nextNodeId: null,
        optionName: '',
        price: 0
      }
      this.optModalVisible = true
    },

    /** 保存分支 */
    async saveOption() {
      this.optSaving = true
      try {
        await addBranchOption(this.optForm)
        message.success('保存成功')
        this.optModalVisible = false
        // 重新加载当前节点的分支列表
        this.selectNode(this.selectedNode)
      } catch (e) {
        message.error('保存失败')
      } finally {
        this.optSaving = false
      }
    },

    /** 删除分支 */
    deleteOption(optionId) {
      this.$confirm({
        title: '确认删除此分支选项?',
        content: '删除后此选项将永久丢失，且与该选项关联的下一节点也将断开。确定要继续吗？',
        okText: '确认删除',
        okType: 'danger', // 红色按钮表示危险操作
        cancelText: '取消',

        onOk: async () => {
          try {
            await delBranchOption(optionId);

            // 2. 成功提示
            this.$message.success('分支选项删除成功');

            this.selectNode(this.selectedNode);

          } catch (e) {
            this.$message.error(`分支选项删除失败: ${e.message || '未知错误'}`);
          }
        },

        onCancel() {
        },
      });
    },
    handleVideo(info) {
      const file = info.file;

      // 1. 自动提取文件名作为 nodeName
      // const fileName = file.name.split('.').slice(0, -1).join('.')
      // this.nodeForm.nodeName = fileName // 自动回填 nodeName

      if (file.status === 'uploading') {
        this.uploadLoading = true;
        return;
      }

      let that = this;
      that.nodeForm.videoUrl = "" // 重置 URL

      new UploadFileToVOD([file], {
        success: function (videoUrlList) {
          that.nodeForm.videoUrl = videoUrlList[0]; // 回填视频 URL
          that.uploadLoading = false;
        },
        vProgress: function (val) {
          that.uploadSize = val * 100;
        }
      });
      // ⚠️ 移除错误的同步赋值
      // that.uploadLoading = false;
    },

    /** 英文视频上传 */
    handleVideoEn(info) {
      if (info.file.status === 'uploading') {
        this.uploadLoadingEn = true;
        return;
      }
      let that = this
      that.nodeForm.videoUrlEn = ""
      new UploadFileToVOD([info.file], {
        success: function (videoUrlList) {
          that.nodeForm.videoUrlEn = videoUrlList[0];
          that.uploadLoadingEn = false;
        },
        vProgress: function (val) {
          that.uploadEnSize = val * 100;
        }
      });
      // that.uploadLoadingEn = false; 
    },

    /** 日语视频上传 */
    handleVideoJa(info) {
      if (info.file.status === 'uploading') {
        this.uploadLoadingJa = true;
        return;
      }
      let that = this
      that.nodeForm.videoUrlJa = ""
      new UploadFileToVOD([info.file], {
        success: function (videoUrlList) {
          that.nodeForm.videoUrlJa = videoUrlList[0];
          that.uploadLoadingJa = false;
        },
        vProgress: function (val) {
          that.uploadJaSize = val * 100;
        }
      });
      // that.uploadLoadingJa = false; 
    },

    /** 印尼视频上传 */
    handleVideoId(info) {
      if (info.file.status === 'uploading') {
        this.uploadLoadingId = true;
        return;
      }
      let that = this
      that.nodeForm.videoUrlId = ""
      new UploadFileToVOD([info.file], {
        success: function (videoUrlList) {
          that.nodeForm.videoUrlId = videoUrlList[0];
          that.uploadLoadingId = false;
        },
        vProgress: function (val) {
          that.uploadIdSize = val * 100;
        }
      });
      // that.uploadLoadingId = false; 
    },

    /** 葡语视频上传 */
    handleVideoPt(info) {
      if (info.file.status === 'uploading') {
        this.uploadLoadingPt = true;
        return;
      }
      let that = this
      that.nodeForm.videoUrlPt = ""
      new UploadFileToVOD([info.file], {
        success: function (videoUrlList) {
          that.nodeForm.videoUrlPt = videoUrlList[0];
          that.uploadLoadingPt = false;
        },
        vProgress: function (val) {
          that.uploadPtSize = val * 100;
        }
      });
      // that.uploadLoadingPt = false; 
    },

    /** 西语视频上传 */
    handleVideoEs(info) {
      if (info.file.status === 'uploading') {
        this.uploadLoadingEs = true;
        return;
      }
      let that = this
      that.nodeForm.videoUrlEs = ""
      new UploadFileToVOD([info.file], {
        success: function (videoUrlList) {
          that.nodeForm.videoUrlEs = videoUrlList[0];
          that.uploadLoadingEs = false;
        },
        vProgress: function (val) {
          that.uploadEsSize = val * 100;
        }
      });
      // that.uploadLoadingEs = false; 
    },
  }
}
</script>

<style scoped>
.branch-editor {
  padding: 8px;
}

/* 移除旧的 .selected-node 样式 */

/* 针对 a-tree 的自定义选中样式 */
/* 注意：需要针对插槽内部的元素进行样式控制 */
.selected-node-tree {
  /* 模仿列表的选中背景和左侧蓝线 */
  background-color: #e6f7ff;
  border-left: 3px solid #1890ff;
  /* 调整 padding/margin 使自定义背景能覆盖整个区域 */
  padding: 4px 8px;
  margin: -4px -8px;
  display: block;
  /* 确保背景覆盖整个宽度 */
}

/* 覆盖 AntD 默认选中样式，使其不干扰自定义样式 */
:deep(.ant-tree-node-content-wrapper.ant-tree-node-selected) {
  background-color: transparent !important;
}
</style>